export default "__VITE_ASSET__KWWNz7Nb__"